
<template >
  <d2-container>

    <div style="text-align: center;padding-top: 20px;font-weight: bold;font-size: 17px;">
      <span v-if="discountApply.discountItem=='PAYALL'&& discountApply.discountType=='MONEY'"> {{discountApply&&discountApply.applyUser?discountApply.applyUser.nickName:''}} 为墓穴 {{discountApply&&discountApply.tombType?discountApply.tombType.thombTypeName:''}}{{discountApply&&discountApply.area?discountApply.area.areaName:''}}{{discountApply&&discountApply.tomb?discountApply.tomb.rowNo+'排':''}} {{discountApply&&discountApply.tomb?discountApply.tomb.columNo+'号':''}}
      </br>
        <span >申请全款优惠项目 {{discountApply.discountMoney}}元</span>  
      </span>
      <!-- <span v-if="discountApply.discountItem=='PAYALL'&& (discountApply.discountType=='DISCOUNT')"> {{discountApply&&discountApply.applyUser?discountApply.applyUser.nickName:''}} 为墓穴 {{discountApply&&discountApply.tombType?discountApply.tombType.thombTypeName:''}}{{discountApply&&discountApply.area?discountApply.area.areaName:''}}{{discountApply&&discountApply.tomb?discountApply.tomb.rowNo+'排':''}} {{discountApply&&discountApply.tomb?discountApply.tomb.columNo+'号':''}}
        </br>申请全款优惠项目 {{discountApply.discountMoney}}折
        <span v-if="discountApply.noCountMoney>0">
          </br>
        </span>{{discountApply.noCountMoney>0?"抹零金额"+discountApply.noCountMoney+"元":""}}优惠</span> -->

        <!-- <span v-if="discountApply.discountItem=='PAYALL'&& discountApply.discountType=='MONEY'"> {{discountApply&&discountApply.applyUser?discountApply.applyUser.nickName:''}} 为墓穴 {{discountApply&&discountApply.tombType?discountApply.tombType.thombTypeName:''}}{{discountApply&&discountApply.area?discountApply.area.areaName:''}}{{discountApply&&discountApply.tomb?discountApply.tomb.rowNo+'排':''}} {{discountApply&&discountApply.tomb?discountApply.tomb.columNo+'号':''}}
        </br>
        <span v-if="discountApply.baseDiscountMoney > 0">
          申请全款优惠项目{{discountApply.discountNum}}折
        </span>
        <span v-else>申请全款优惠项目 {{discountApply.discountMoney}}元</span>  
      </span>
      <span v-if="discountApply.discountItem=='PAYALL'&& (discountApply.discountType=='DISCOUNT')"> {{discountApply&&discountApply.applyUser?discountApply.applyUser.nickName:''}} 为墓穴 {{discountApply&&discountApply.tombType?discountApply.tombType.thombTypeName:''}}{{discountApply&&discountApply.area?discountApply.area.areaName:''}}{{discountApply&&discountApply.tomb?discountApply.tomb.rowNo+'排':''}} {{discountApply&&discountApply.tomb?discountApply.tomb.columNo+'号':''}}
        </br>申请全款优惠项目 {{discountApply.discountMoney}}折
        <span v-if="discountApply.noCountMoney>0">
          </br>
        </span>{{discountApply.noCountMoney>0?"抹零金额"+discountApply.noCountMoney+"元":""}}优惠</span> -->
      <span v-if="discountApply.discountItem=='MANAGE'&& discountApply.discountType=='MONEY'"> {{discountApply&&discountApply.applyUser?discountApply.applyUser.nickName:''}} 为墓穴 {{discountApply&&discountApply.tombType?discountApply.tombType.thombTypeName:''}}{{discountApply&&discountApply.area?discountApply.area.areaName:''}}{{discountApply&&discountApply.tomb?discountApply.tomb.rowNo+'排':''}} {{discountApply&&discountApply.tomb?discountApply.tomb.columNo+'号':''}}
        </br>申请管理费优惠项目 {{discountApply.discountMoney}}元</span>
      <span v-if="discountApply.discountItem=='MANAGE'&& discountApply.discountType=='DISCOUNT'"> {{discountApply&&discountApply.applyUser?discountApply.applyUser.nickName:''}} 为墓穴 {{discountApply&&discountApply.tombType?discountApply.tombType.thombTypeName:''}}{{discountApply&&discountApply.area?discountApply.area.areaName:''}}{{discountApply&&discountApply.tomb?discountApply.tomb.rowNo+'排':''}} {{discountApply&&discountApply.tomb?discountApply.tomb.columNo+'号':''}}
        </br>申请管理费优惠项目 {{discountApply.discountMoney}}折
        <span v-if="discountApply.noCountMoney>0">
          </br>
        </span>{{discountApply.noCountMoney>0?"抹零金额"+discountApply.noCountMoney+"元":""}}优惠</span>

    </div>
    <el-timeline style="padding-top: 50px;">
      <el-timeline-item v-for="(activity, index) in activities"
                        :key="index"
                        :timestamp="activity.timestamp">
        {{activity.content}}
      </el-timeline-item>
    </el-timeline>
    <el-form ref="infoForm">

      <el-form-item label="优惠申请备注"
                    label-width="140px"
                    class="formItem"
                    prop="remark">
        {{discountApply.remark}}
      </el-form-item>

    </el-form>
    <div style="text-align:center;padding-top:1rem"
         v-if="!discountApply.isEnd&&discountApplyDetail.approveState=='0'&&discountApply.state=='0' ">

      <el-form ref="remarkForm"
               :rules="rules"
               :model="info">

        <el-form-item label="备注"
                      :label-width="formLabelWidth"
                      prop="remark">
          <el-input v-model="info.remark"
                    autocomplete="off"
                    style="width:88%"></el-input>
        </el-form-item>

      </el-form>

      <div style="padding-top:10px">
        <el-button type="success"
                   @click="onSubmit(true)"
                   style="width:90%;height:3rem;font-size:1.5rem">通过</el-button>
      </div>
      <div style="padding-top:10px">
        <el-button type="success"
                   @click="onSubmit(false)"
                   style="width:90%;height:3rem;font-size:1.5rem;margin-left: 0px;">拒绝</el-button>
      </div>
    </div>
    <div style="text-align:center;padding-top:2rem"
         v-if="discountApply.isEnd&&discountApply.state=='0'">
      <i class="el-icon-success"
         style="font-size:4em;color:#07c160;"
         v-if="discountApply.isAllApproved"></i>
      <el-button type="success"
                 disabled
                 v-if="discountApply.isAllApproved"
                 style="width:90%;height:3rem;font-size:1.5rem;margin-top:1rem">申请已通过</el-button>
      <i class="el-icon-error"
         style="font-size:4em;color:#cc5656;"
         v-if="!discountApply.isAllApproved"></i>
      <el-button type="success"
                 disabled
                 v-if="!discountApply.isAllApproved"
                 style="width:90%;height:3rem;font-size:1.5rem;margin-top:1rem">申请未通过</el-button>
    </div>
    <div style="text-align:center;padding-top:2rem"
         v-if="!discountApply.isEnd&&discountApplyDetail.approveState!='0'&&discountApply.state=='0'">
      <div>
        <i class="el-icon-success"
           style="font-size:4em;color:#07c160;"
           v-if="discountApplyDetail.approveState=='1'"></i>
        <i class="el-icon-error"
           style="font-size:4em;color:#cc5656;"
           v-if="discountApplyDetail.approveState=='2'"></i>
      </div>
      <el-button type="success"
                 disabled
                 style="width:90%;height:3rem;font-size:1.5rem;margin-top:1rem">{{discountApplyDetail&&discountApplyDetail.sRole?discountApplyDetail.sRole.roleName:''}}{{discountApplyDetail.approveState==1?'已通过':'已拒绝'}}</el-button>
    </div>
    <div style="text-align:center;padding-top:2rem"
         v-if="discountApply.state=='1'">
      <div>

        <i class="el-icon-error"
           style="font-size:4em;color:#cc5656;"></i>
      </div>
      <el-button type="success"
                 disabled
                 style="width:90%;height:3rem;font-size:1.5rem;margin-top:1rem">申请已失效</el-button>
    </div>
  </d2-container>
</template>
<script>
import { mapActions } from "vuex";
import util from "@/libs/util";
import dateUtil from "@/utils/dateUtil";
export default {
  title: "自定义列模板",
  index: 14,
  data() {
    return {
      reverse: true,
      activities: [],
      openId: this.$route.query.openId, //微信openid可以确定user
      discountApplyId: this.$route.query.discountApplyDetailId, //优惠申请id
      discountApplyDetail: {},
      formLabelWidth: "80px",
      discountApply: {}, //优惠申请信息
      discountApplyDetail: [],
      rules: {
        remark: [
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: "blur",
          },
        ],
      },
      info: {
        remark: "",
      },
    };
  },
  methods: {
    ...mapActions("d2admin/discount", [
      "searchDiscountApplyDetailById",
      "doApproveDiscountApplyDetail",
    ]),
    onSubmit(isAgree) {
      this.$refs.remarkForm.validate((valid) => {
        if (valid) {
          this.loading = this.$loading({
            fullscreen: true,
            text: "加载中",
            background: "rgba(0, 0, 0, 0.6)",
          });
          this.doApproveDiscountApplyDetail({
            vm: this,
            openId: this.openId,
            applyDetailId: this.$route.query.discountApplyDetailId,
            isAgree: isAgree,
            remark: this.info.remark,
          });
        }
      });
    },
    fmtDate(date, fmt) {
      return dateUtil.formatDate(date, fmt);
    },
    reresh() {
      this.searchDiscountApplyDetailById({
        vm: this,
        discountApplyDetailId: this.$route.query.discountApplyDetailId,
      });
    },
  },
  mounted() {
    this.reresh();
  },
};
</script>
<style lang="scss">
@import "../../login/style.scss";
.el-message-box {
  width: 80%;
}
.formItem .el-form-item__content {
  width: 18rem;
}
</style>